import React, { Component } from "react";
import { connect } from "react-redux";
import LabelsCode from "../js/admin/LabelsCode";
import { withRouter } from "react-router-dom";
import EntityPage from "../components/EntityPage";
import auth, { get, getMyImageUrl, post, setRem } from "../js/auth";
import EatWithMeText from "../components/EatWIthMeText";
import MenuItemHeader from "../components/MenuItemHeader";
import ChangeLanguage from "../components/icon-buttons/ChangeLanguage";
import UserImageButton from "../components/icon-buttons/UserImageButton";
import { I18n } from "react-redux-i18n";


class Chat extends Component {

    sendPhotoMessage = (file) => {
        if (this.rocketRoomId && this.rocketHeaders && file) {
            // Compress image before upload
            const img = document.createElement('img');
            const reader = new FileReader();
            reader.onload = (e) => {
                img.onload = () => {
                    const MAX_SIZE = 1024; // px
                    let w = img.width;
                    let h = img.height;
                    if (w > MAX_SIZE || h > MAX_SIZE) {
                        if (w > h) {
                            h = h * (MAX_SIZE / w);
                            w = MAX_SIZE;
                        } else {
                            w = w * (MAX_SIZE / h);
                            h = MAX_SIZE;
                        }
                    }
                    const canvas = document.createElement('canvas');
                    canvas.width = w;
                    canvas.height = h;
                    const ctx = canvas.getContext('2d');
                    ctx.drawImage(img, 0, 0, w, h);
                    canvas.toBlob((blob) => {
                        const formData = new FormData();
                        formData.append("file", blob, file.name.replace(/\.[^/.]+$/, "") + ".jpg");
                        // Optionally add a description
                        // formData.append("description", "Photo");
                        fetch(`${this.rocketApiBase}/rooms.upload/${this.rocketRoomId}`, {
                            method: "POST",
                            headers: {
                                "X-Auth-Token": this.rocketHeaders["X-Auth-Token"],
                                "X-User-Id": this.rocketHeaders["X-User-Id"]
                            },
                            body: formData
                        })
                            .then(res => res.json())
                            .then(() => {
                                this.fetchRocketMessages();
                            })
                            .catch(e => this.setState({ error: "Photo send error: " + e.message }));
                    }, "image/jpeg", 0.8);
                };
                img.src = e.target.result;
            };
            reader.readAsDataURL(file);
        }
    }
    prevMessagesLength = 0;
    messagesEndRef = React.createRef();
    pollInterval = null;
    // Rocket.Chat REST API endpoints
    rocketApiBase = "https://chat.eatwithme.online/api/v1";
    rocketRoomId = null;
    rocketUserId = null;

    state = {
        token: this.props.token || null,
        id: this.props.id || null,
        messages: [],
        newMessage: "",
        loading: false,
        error: null
    }

    show = () => {
        return auth.device.platform !== "browser";
    }

    initRocketRoom = () => {
        if (this.initRocketRoomInProgress) {
            return;
        }
        // Get room id by name
        if (this.show() && !this.state.roomInitialized && this.props.myStatus && this.props.myStatus.restaurant_name && this.props.myStatus.restaurant_global_id) {
            const roomName = (this.props.myStatus.restaurant_name.normalize("NFD").replace(/[^a-zA-Z0-9 _.-]/g, "").replace(/\s+/g, "-") + "-" + this.props.myStatus.restaurant_global_id).replace(/--/g, "-");
            this.initRocketRoomInProgress = true;
            get(`${this.rocketApiBase}/groups.info?roomName=${roomName}`, undefined, this.getRocketHeaders(), undefined, undefined, false)
                .done(data => {

                    if (data.group && data.group._id) {
                        this.rocketRoomId = data.group._id;
                        this.fetchRocketMessages();
                        this.setState({ roomInitialized: true }, () => {
                            this.initRocketRoomInProgress = false;
                        });
                    } else {
                        this.setState({ error: "Room not found" }, () => {
                            this.initRocketRoomInProgress = false;
                        });
                    }
                })
                .fail((error) => {
                    this.setState({ token: null, roomInitialized: true }, () => {
                        this.initRocketRoomInProgress = false;
                    });
                });
        }
    }

    fetchRocketMessages = () => {
        if (this.rocketRoomId && this.getRocketHeaders()) {
            this.setState({ loading: true });
            get(`${this.rocketApiBase}/groups.messages?roomId=${this.rocketRoomId}&count=20`, undefined, this.getRocketHeaders(), undefined, undefined, false)
                .done(data => {
                    const newMessages = data.messages || [];
                    // Compare by message id and length
                    const currentMessages = this.state.messages;
                    const isDifferent =
                        newMessages.length !== currentMessages.length ||
                        newMessages.some((msg, i) => !currentMessages[i] || msg._id !== currentMessages[i]._id);
                    if (isDifferent) {
                        this.setState({ messages: newMessages, loading: false }, () => {
                            this.scrollToBottom();
                            this.prevMessagesLength = newMessages.length;
                        });
                    } else {
                        this.setState({ loading: false });
                    }
                })
                .fail(() => this.setState({ error: "Message fetch error", loading: false }));
        }
    }

    sendRocketMessage = () => {
        if (this.rocketRoomId && this.getRocketHeaders() && this.state.newMessage.trim()) {
            post(`${this.rocketApiBase}/chat.postMessage`,
                { roomId: this.rocketRoomId, text: this.state.newMessage },
                this.getRocketHeaders(),
                undefined,
                undefined,
                undefined,
                undefined,
                false
            ).done(() => {
                this.setState({ newMessage: "" }, () => {
                    this.fetchRocketMessages();
                });
            })
                .fail((e) => this.setState({ error: "Send error: " + e.message }));
        }
    }

    scrollToBottom = () => {
        // Wait for images to load before scrolling
        const scroll = () => {
            if (this.messagesEndRef.current) {
                this.messagesEndRef.current.scrollIntoView({ behavior: "smooth" });
            }
        };
        // Find all images in the chat log
        const chatLog = this.messagesEndRef.current?.parentNode;
        if (chatLog) {
            const images = chatLog.querySelectorAll('img');
            let loaded = 0;
            if (images.length === 0) {
                scroll();
            } else {
                images.forEach(img => {
                    if (img.complete) {
                        loaded++;
                    } else {
                        img.addEventListener('load', () => {
                            loaded++;
                            if (loaded === images.length) {
                                scroll();
                            }
                        }, { once: true });
                        img.addEventListener('error', () => {
                            loaded++;
                            if (loaded === images.length) {
                                scroll();
                            }
                        }, { once: true });
                    }
                });
                if (loaded === images.length) {
                    scroll();
                }
            }
        } else {
            scroll();
        }
    }



    //get the login token from https://instance.eatwithme.online/eatwithme.server/rocket/login

    initialize = () => {
        auth.minfontsize = 6;
        setRem();
        if (!this.state.token && this.props.myStatus && this.props.myStatus.restaurant_id) {
            // Start polling for new messages if browser
            if (this.show()) {
                this.pollInterval = setInterval(() => {
                    if (this.rocketRoomId && this.getRocketHeaders()) {
                        this.fetchRocketMessages();
                    }
                }, 5000);
            }

            get("https://instance.eatwithme.online/eatwithme.server/rocket/login", undefined, undefined, undefined, false).done(res => {
                if (res.authToken && res.userId) {
                    this.setState({ token: res.authToken, id: res.userId });
                    this.rocketUserId = res.userId;

                    this.initRocketRoom();
                } else {
                    this.setState({ token: "error" });
                }

            }).fail((error) => {
                auth.ajaxError = false;
                this.setState({ token: "error" });
            });
        } else if (this.state.token && this.getRocketHeaders()) {
            this.initRocketRoom();
        }
    }

    getRocketHeaders = () => {
        if (this.state.token && this.state.id) {
            return {
                "X-Auth-Token": this.state.token,
                "X-User-Id": this.state.id,
                "Content-Type": "application/json"
            };
        }
        return null;
    }

    componentDidMount() {
        this.initialize();
    }

    componentDidUpdate() {
        this.initialize();
    }

    render() {
        if (!this.props.myStatus || !this.props.myStatus.restaurant_id) {
            return (<div></div>);
        }
        // ...existing code for non-browser platforms
        // If not browser, fallback to iframe embed (legacy)
        const room = (this.props.myStatus.restaurant_name.normalize("NFD").replace(/[^a-zA-Z0-9 _.-]/g, "").replace(/\s+/g, '-') + "-" + this.props.myStatus.restaurant_global_id).replace(/--/g, "-");
        const chatUrl = "https://chat.eatwithme.online/group/" + room + "?layout2=embedded&lang=hu-HU&resumeToken=" + this.state.token;
        return (
            <div style={{ display: "flex", flexFlow: "column", flexGrow: 1, overflow: "hidden", maxHeight: "100%", height: "100%" }}>
                {this.props.showHeader && (
                    <div className="menuItemHeader bar">
                        <EatWithMeText />
                        <MenuItemHeader {...this.props} header={I18n.t("admin_local.menus.chat_with_support")} />
                        <div style={{ display: "flex", justifyContent: "flex-end", alignItems: "center" }}>
                            <ChangeLanguage />
                            <UserImageButton src={getMyImageUrl()} />
                        </div>
                    </div>
                )}
                <div style={{ flex: 1, padding: 16, display: "flex", flexDirection: "column", overflow: "hidden" }}>
                    {this.show() ? (
                        <>
                            {this.state.error && <div style={{ color: "red" }}>{this.state.error}</div>}
                            <div style={{ flexGrow: 1, overflowY: "auto", marginBottom: 16, border: "1px solid #eee", borderRadius: 8, padding: 8, background: "#fafafa", minHeight: 0 }}>
                                {(() => {
                                    const messages = [...this.state.messages].reverse();
                                    let lastUsername = null;
                                    let lastTimestamp = null;
                                    const grouped = messages.map((msg, i) => {
                                        const username = msg.u?.username || "user";
                                        const name = msg.u?.name || "";
                                        const timestamp = msg.ts ? new Date(msg.ts) : null;
                                        let showHeader = true;
                                        if (lastUsername === username && lastTimestamp && timestamp) {
                                            const diff = Math.abs(timestamp - lastTimestamp) / (1000 * 60); // minutes
                                            if (diff <= 10) {
                                                showHeader = false;
                                            }
                                        }
                                        if (showHeader) {
                                            lastUsername = username;
                                            lastTimestamp = timestamp;
                                        }
                                        return (
                                            <div key={msg._id} style={{ marginBottom: 16 }}>
                                                {showHeader && (
                                                    <div style={{ fontSize: "1.2rem", color: "#555", marginBottom: 2, display: "flex", alignItems: "center" }}>
                                                        {name && <span>{name}</span>}
                                                        {name && username && <span> &nbsp; </span>}
                                                        {username && <span>({username})</span>}
                                                        {timestamp && <span style={{ marginLeft: 12, color: "#888" }}>{timestamp.toLocaleString()}</span>}
                                                    </div>
                                                )}
                                                <div style={{ fontSize: "2.5rem" }}>
                                                    {msg.msg}
                                                </div>
                                                {msg.attachments && msg.attachments.map((att, i) => (
                                                    att.image_url ? (
                                                        <div key={i} style={{ marginTop: 8 }}>
                                                            <img
                                                                src={att.image_url.startsWith('/') ? `https://chat.eatwithme.online${att.image_url}` : att.image_url}
                                                                alt={att.title || 'uploaded'}
                                                                style={{ maxWidth: '100%', maxHeight: 300, borderRadius: 8 }}
                                                            />
                                                        </div>
                                                    ) : null
                                                ))}
                                            </div>
                                        );
                                    });
                                    return grouped;
                                })()}
                                <div ref={this.messagesEndRef} />
                            </div>
                            <div style={{ display: "flex", gap: 8 }}>
                                <input
                                    type="text"
                                    value={this.state.newMessage}
                                    onChange={e => this.setState({ newMessage: e.target.value })}
                                    style={{ flex: 1, fontSize: "2.5rem" }}
                                    placeholder={I18n.t("local.feedback.typeMessagePlaceholder", { defaultValue: "Type a message..." })}
                                />
                                <button className="btn btn-primary" style={{ fontSize: "2.5rem" }} onClick={this.sendRocketMessage}>{I18n.t("local.feedback.sendLabel", { defaultValue: "Send" })}</button>
                                <input
                                    type="file"
                                    accept="image/*"
                                    capture="environment"
                                    ref={this.fileInputRef}
                                    style={{ display: "none" }}
                                    onChange={e => {
                                        const file = e.target.files[0];
                                        if (file) this.sendPhotoMessage(file);
                                        e.target.value = "";
                                    }}
                                />
                                <button
                                    className="btn btn-secondary icon-camera"
                                    style={{ fontSize: "2.5rem" }}
                                    onClick={() => this.fileInputRef.current && this.fileInputRef.current.click()}
                                    title="Send photo"
                                ></button>
                            </div>
                        </>
                    ) : (
                            <div key={this.state.token} style={{ display: "flex", flexFlow: "column", flexGrow: 1, overflow: "hidden", maxHeight: "100%", height: "100%" }}>
                            <iframe
                                src={chatUrl}
                                width="100%"
                                height="100%"
                                frameBorder="0"
                            ></iframe>
                        </div >
                    )
                    }
                </div >
            </div >
        )
    }

}
const mapStateToProps = (props, state) => {
    if (props.rootReducer.myStatus && props.rootReducer.myStatus.restaurant_id) {
        return {
            myStatus: props.rootReducer.myStatus,
        };
    }
    return {};
};

export default connect(mapStateToProps)(withRouter(Chat));
